import angular from 'angular';
import moment from 'moment';

angular.module('cxRelations').directive('cxRelEidWizard', [
  function() {
    return {
      restrict: 'E',
      template: require('./relEidWizard.html'),
      controllerAs: 'vm',
      scope: {
        success: '&',
        options: '=',
        saving: '=?disabled',
      },
      bindToController: true,
      controller: [
        '$http',
        'appUrls',
        'flySvc',
        'enumCacheSvc',
        'dataCache',
        'relBindSvc',
        function($http, appUrls, flySvc, enumCacheSvc, dataCache, relBindSvc) {
          const vm = this;
          vm.saving = false;
          vm.similar = [];
          vm.relTypes = [];
          vm.crmTypes = [];
          vm.languages = dataCache.getArray('language');
          vm.showValidation = false;
          vm.teams = [];
          vm.tags = [];

          vm.$onInit = function() {
            $http.get(`${appUrls.api}/api/Resource/Tags`).then(({ data }) => {
              vm.options.tags = data;
              vm.tagsDisabled = !checkSecurity('Tags:c');
              vm.tags = vm.options.tags;
            });
          };

          vm.companies = dataCache.getArray('company');

          enumCacheSvc.get('relationType').then(function(data) {
            vm.relTypes = data.filter(x => x.key !== 0);
          });
          enumCacheSvc.get('crmType').then(function(data) {
            vm.crmTypes = data;
          });
          vm.setCardInfo = function(eid) {
            vm.cardInformation = eid;
            vm.similar = [];
            if (!!eid) {
              if (vm.cardInformation.nationality === 'Belge') {
                vm.cardInformation.language = 'fr';
              } else if (vm.cardInformation.nationality === 'Belg') {
                vm.cardInformation.language = 'nl';
              }
              if (!vm.cardInformation.companyId) {
                vm.cardInformation.companyId = vm.options.company.id;
              }
              $http
                .post(`${appUrls.api}/api/relation/SimilarEid`, vm.cardInformation)
                .then(function(response) {
                  if (response && response.data) {
                    vm.similar = response.data.similar || [];

                    if (response.data.kbo && response.data.kbo.length) {
                      vm.cardInformation.enterpriseNumber = response.data.kbo[0].number;
                      if (!vm.options.relTypeDisabled) vm.cardInformation.relationType = 1;
                    } else if (!vm.options.relTypeDisabled) {
                      vm.cardInformation.relationType = 2;
                    }
                  }
                });
            }
          };
          vm.validate = function() {
            if (!vm.cardInformation) return false;
            if (!vm.cardInformation.lastName) return false;
            if (!vm.cardInformation.relationType && vm.cardInformation.relationType !== 0)
              return false;
            if (!vm.cardInformation.crmType && vm.cardInformation.crmType !== 0) return false;
            if (!vm.cardInformation.language) return false;
            return true;
          };
          vm.create = function() {
            if (vm.saving || !vm.validate()) return;
            vm.saving = true;
            vm.cardInformation.teams = vm.teams;
            vm.cardInformation.tags = vm.tags;

            $http.post(appUrls.api + '/api/relation/CreateRelationEid', vm.cardInformation).then(
              function(result) {
                vm.saving = false;
                vm.success({
                  relation: result.data,
                  isNew: true,
                });
              },
              function(error) {
                vm.saving = false;
                flySvc.error(error.data.code, error.data.parameters);
              },
            );
          };
          vm.open = function(rel) {
            if (vm.saving || !vm.cardInformation) return;
            vm.success({
              relation: rel,
              isNew: false,
            });
          };
          vm.update = function(rel) {
            if (vm.saving || !vm.cardInformation) return;
            vm.saving = true;
            var model = angular.copy(vm.cardInformation);

            model.relationId = rel.id;
            model.dateOfBirth = moment.utc(model.dateOfBirth);
            model.cardExpiryDate = moment.utc(model.cardExpiryDate);

            $http.put(appUrls.api + '/api/relation/UpdateRelationEid', model).then(
              function(result) {
                vm.saving = false;
                relBindSvc.updateRelation(rel.id, result.data.changes, null);
                flySvc.success('msgRelationUpdated');
                vm.success({
                  relation: rel,
                  isNew: false,
                });
              },
              function(error) {
                vm.saving = false;
                flySvc.error(error.data.code, error.data.parameters);
              },
            );
          };
        },
      ],
    };
  },
]);
